import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("account", ["user"]),
    isTeacher() {
      return this.user?.account_type == "TEACHER" ? true : false;
    }
  }
};
